import { storage } from "@/firebase"

const uploadImg = async (idLead, file) => {
    try {
        const imgNameSaved = new Date().getTime()
        const pathSaved = `leads/${idLead}/${imgNameSaved}`
        const storageWS_REF = storage.ref(pathSaved)
        var task = storageWS_REF.put(file);
        await new Promise((resolve, reject) => {
            task.on('state_changed',
                function progress(snapshot) {
                    var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                },
                function error(err) {
                    console.error(`uploadImg - ${err}`)
                    reject(err)
                },
                function complete() {
                    var downloadURL = task.snapshot.downloadURL;
                    resolve("Download Complet")
                }
            );
        })
        return pathSaved
    } catch (error) {
        console.error("uploadImg ",error)
    }
}
const uploadFile = async (idLead, file) => {
    try {
        const fileName = `${new Date().getTime()}_${file.name}`;
        const filePath = `leads/${idLead}/${fileName}`;

        const storageRef = storage.ref(filePath);

        const uploadTask = storageRef.put(file);

        await new Promise((resolve, reject) => {
            uploadTask.on(
                "state_changed",
                function progress(snapshot) {
                    const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                function error(err) {
                    reject(err);
                },
                function complete() {
                    resolve();
                }
            );
        });
        // const downloadURL = await storageRef.getDownloadURL();
        return filePath;
    } catch (error) {
        console.error("Erro ao fazer upload do arquivo:", error.message);
        throw error;
    }
}
const downloadImg = async (path) => {
    try {
        const fileRef = storage.ref(path);
        const downloadURL = await fileRef.getDownloadURL();
        const response = await fetch(downloadURL);
        const blob = await response.blob();
        return blob;
    } catch (error) {
        console.error(error)
    }
}
const deleteImg = async (path) => {
    try{
        await storage.ref(path).delete()
    }catch(err){
        console.error(`Error - deleteImg ${err}`)
    }
}

export default {
    uploadImg,
    deleteImg,
    uploadFile,
    downloadImg
}